import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { canAccess, landingPathFor, normalizeRole } from '../permissions';
import { hasValidStaffSession } from '../auth/session';
import { useLiveData } from '../hooks/useLiveData';
import { ipApi } from '../services/api';
import { mergeEmrSettings } from '../config/emrSettings';

export default function RoleGuard({ children }) {
  const { isLoggedIn, user } = useAuth();
  const location = useLocation();
  const { data: emrData } = useLiveData(() => ipApi.getEmrSettings(), []);
  const roleModuleAccess = mergeEmrSettings(emrData?.settings).roleModuleAccess || {};

  if (!isLoggedIn || !hasValidStaffSession()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  const path = location.pathname;
  const role = normalizeRole(user.role);
  if (!canAccess(role, path, roleModuleAccess)) {
    return <Navigate to={landingPathFor(role)} replace />;
  }

  return children;
}
